import { GraduationCap, RotateCcw } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Switch } from "@/components/ui/switch";

export function StudentModeMenu() {
    const { user, refresh } = useAuth();
    const on = !!user?.student_mode;

    const toggle = async (e) => {
        e.preventDefault();
        try {
            await api.put("/me/student-mode", { enabled: !on });
            await refresh();
            toast.success(!on ? "Mode élève activé : les cours se débloquent en réussissant les examens." : "Mode élève désactivé : accès libre à tous les cours.");
        } catch { toast.error("Action impossible."); }
    };

    const reset = async (e) => {
        e.preventDefault();
        if (!window.confirm("Réinitialiser votre progression (sourates et cours audio débloqués) ?")) return;
        try {
            await api.delete("/me/course-progress");
            toast.success("Progression réinitialisée.");
        } catch { toast.error("Action impossible."); }
    };

    return (
        <>
            <DropdownMenuItem onSelect={toggle} className="rounded-md cursor-pointer focus:bg-[#FAF6EC]" data-testid="menu-student-mode">
                <span className="flex items-center gap-2.5 px-3 py-2 text-sm w-full">
                    <GraduationCap className="w-4 h-4" style={{ color: "var(--gold-500)" }} />
                    <span className="flex-1">Mode élève<span className="block text-[11px]" style={{ color: "var(--text-tertiary)" }}>Suivre le programme avec les verrous</span></span>
                    <Switch checked={on} className="pointer-events-none" data-testid="menu-student-mode-switch" />
                </span>
            </DropdownMenuItem>
            {on && (
                <DropdownMenuItem onSelect={reset} className="rounded-md cursor-pointer focus:bg-[#FAF6EC]" data-testid="menu-reset-progress">
                    <span className="flex items-center gap-2.5 px-3 py-2 text-sm">
                        <RotateCcw className="w-4 h-4 opacity-70" />
                        <span>Réinitialiser ma progression</span>
                    </span>
                </DropdownMenuItem>
            )}
        </>
    );
}
